import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
             <span className="purple">About Me</span>
            
             <span className="purple"> </span>
            <br />
            {/* <br />Hello! My name is <span className="purple">Praveen Nanda</span> and I am a front-end developer with a passion for creating intuitive and engaging websites and web applications. I have a strong foundation in  <span className="purple">HTML, CSS </span> and  <span className="purple">JavaScript </span>, and I have experience working with frameworks such as  <span className="purple">React, Angular </span> and  <span className="purple">Vue </span>. In my previous roles, I have worked on a variety of projects ranging from small websites to large web applications, and I have developed a keen eye for detail and a dedication to delivering high-quality work. I am a <span className="purple">team player </span> with <span className="purple">excellent communication </span> and <span className="purple">Problem solving </span> skills, and I am always eager to learn and improve my craft. Thank you for visiting my portfolio, and I hope to work with you on your next project! */}
              <br />I'm a self-taught front-end developer with a passion for creating visually appealing and user-friendly websites. My journey in web development started when I was exploring new technologies and I fell in love with the creativity and problem-solving involved in building websites.
              <br />
              <br />I have a strong understanding of HTML, CSS, and JavaScript and I am proficient in creating responsive designs that adapt to different screen sizes and devices. I'm always seeking to expand my skillset and I have recently started exploring new technologies such as React and Vue.js.
              <br />
              <br />I'm a quick learner and I thrive in a fast-paced environment. I'm also a good communicator and I work well in teams. I believe that collaboration is key to creating great websites and I enjoy working with designers, developers, and project managers to bring projects to life.
              <br />
              <br />When I'm not coding, I enjoy spending time with my family and friends, reading, and traveling. I'm also a big fan of video games and I enjoy playing games on my free time.
              <br />
             
              {/* <br />As a <span className="purple">Front-end developer </span>, I understand the importance of creating user-centered design solutions, and I have experience in <span className="purple">User experience </span> (UX) design. I am always looking for ways to improve my skills and stay up-to-date with the latest <span className="purple">web development </span> trends, and I have also gained expertise in other technical areas such as database management and cloud computing.
            <br /> */}
            <br />I am a team player with excellent communication and problem-solving skills, and I am always eager to learn and improve my craft. Thank you for visiting my portfolio, and I hope to work with you on your next project!
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> <span className="purple">Prototyping and wireframing </span> 
            </li>
            <li className="about-activity">
              <ImPointRight /><span className="purple"> Problem Solving.</span>  
            </li>
            <li className="about-activity">
              <ImPointRight /> <span className="purple"> Accessibility &SEO </span>
            </li>
            <li className="about-activity">
              <ImPointRight /><span className="purple"> Travelling. </span> 
            </li>
            <li className="about-activity">
              <ImPointRight /><span className="purple"> Attending Tech Events. </span> 
            </li>
            <li className="about-activity">
              <ImPointRight /><span className="purple"> Explore new technologies. </span> 
            </li>
          </ul>
          <br />
          <br />Thank you for visiting my portfolio and I look forward to connecting with you soon!
          {/* <h1>Checkout My work in the project section</h1> */}
          <br />
          {/* <span className="purple">Checkout my work in the project section</span> */}
          <br />
          <br />
          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Praveen Nanda</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
